import { SIDEBAR_STATUS } from '../types/sidebarTypes';

export function toggleSideBar(payload: boolean) {   
    return {
        type: SIDEBAR_STATUS,
        payload
    }
}
